import styled, { css } from 'styled-components';

import { Button, Input, Select } from '@xsolla/ui-core';

import {
  ColumnBlock,
  SpaceBetweenBlock,
  VerticalCenterBlock,
  VerticalHorizontalCenterColumnBlock
} from '../../../styled';

export const ErrorWrapper = styled(VerticalHorizontalCenterColumnBlock)`
  min-height: 400px;
  gap: 8px;
`;

export const ErrorDescriptionWrapper = styled.p`
  text-align: center;
`;

export const EmptyTableWrapper = styled(VerticalHorizontalCenterColumnBlock)`
  height: 100%;
`;

export const TableWrapper = styled.div`
  height: 400px;
`;

export const TooltipWrapper = styled.div`
  margin-left: 4px;
`;

export const HeaderWrapper = styled(SpaceBetweenBlock)`
  height: 56px;
  margin-bottom: 24px;
`;

export const HeaderUserWrapper = styled(ColumnBlock)`
  justify-content: flex-end;
  height: 100%;
`;

export const UsernameWrapper = styled.p`
  ${(props) => props.theme.typography.title2};
  margin-bottom: 4px;
`;

export const SearchInputWrapper = styled.div`
  width: 100%;
  max-width: 416px;
  display: flex;
  align-items: end;
  height: 100%;
`;

export const UserIdWrapper = styled.p`
  ${(props) => props.theme.typography.descriptionCompact};
  color: ${(props) => props.theme.colors.muted};
`;

export const SubHeader3Wrapper = styled.p`
  ${(props) => props.theme.typography.subHeader3};
  word-break: break-word;
`;

export const CheckboxWrapper = styled.div`
  input {
    cursor: default;
  }
`;

export const FooterTextWrapper = styled(SubHeader3Wrapper)`
  margin-top: 24px;
`;

export const AttributeKeyWrapper = styled.p`
  ${(props) => props.theme.typography.description};
  font-size: 12px;
  background-color: ${(props) => props.theme.colors.brand}22;
  border-radius: 4px;
  padding: 0 4px;
  word-break: break-all;
`;

export const ValueWrapper = styled.div`
  word-break: break-all;
  margin-right: 6px;
`;

export const EditValueWrapper = styled(VerticalCenterBlock)`
  height: 100%;
`;

const errorStyle = css`
  position: relative;
  top: 5px;
`;

export const ValueInputWrapper = styled(VerticalHorizontalCenterColumnBlock)<{ isError: boolean }>`
  height: 100%;
  min-width: 0;

  div {
    ${(props) => props.isError && errorStyle};
    min-width: 0;
  }
`;

export const ValueInput = styled(Input)`
  height: 32px;
`;

export const ValueSelect = styled(Select)`
  height: 32px;
  min-height: 0;
`;

export const ValueSaveButton = styled(Button)`
  margin-left: 4px;
`;
